
<i
class="material-icons-outlined close-icon"
style="color: #00233A"
(click)="onCancel()"
>close
</i>
<div class="schedulerLoading"  *ngIf="areFiltersLoading">
  <section>
    <div  class="pulsing">
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing">  {{ "Loading" | translate }}...</p>
  </section>
</div>


<div class="row tooltipTemplateContainer"  *ngIf="!areFiltersLoading">
  
   
 
  <div class="row">
    <h1 class="col-lg-12 dialog-title">
      <strong>{{"dateAppointment"| translate}}</strong>
    </h1>
  </div>
<div class="asideContainer">  
  <div class="row ">
    <p class="col-lg-6">
      
      <strong>{{"type" | translate}}:</strong> {{ hoveredData.typeOfService | translate}}
    </p>
    <p class="col-lg-6">
      <strong>{{"Brand" | translate}}:</strong> {{ hoveredData.brandName}}
    </p>
  </div>
  <div class="row ">
    <p class="col-lg-6">
      <strong>{{"Time"| translate}}:</strong> {{ hoveredData.hour}}
    </p>
    <p class="col-lg-6">
      <strong>{{ "Client" | translate }}:</strong> {{ hoveredData.clientFirstName
      }}
      <ng-container *ngIf="showLastName">
        {{ hoveredData.clientLastName }}
      </ng-container>
    </p>
  </div>
  <div class="row ">
    <p class="col-lg-6">
      <strong>{{ "Plate" | translate }}:</strong> {{ hoveredData.plateNo}}
    </p>
    <p class="col-lg-6">
      <strong>Email:</strong> {{ hoveredData.email}}
    </p>
  </div>
  
   <div class="row ">
    <p class="col-lg-6">
      <strong>{{ "Phone" | translate }}:</strong> {{ hoveredData.contactNumber}}
    </p>
    <p class="col-lg-6">
     
    </p>
  </div>
  <div class="row "  *ngIf="userProfile.role.canSetNoShow && DisableShowNoShow()">
  
    <p class="col-lg-5" style="color: #19BEE7; top:0.5rem">
      <strong>{{ "AttendanceAtTheAppointment" | translate }}</strong>
    </p>
    <div class="col-lg-7 modifiersContainerpopuop d-flex justify-content-start" > 
      <button class="state-modifier-false" (click)="clientAssisted(2)" >
          {{ "CheckIn" | translate }}
      </button>
      <button class="state-modifier-false" (click)="clientAssisted(3)">
          {{ "NotAssisted" | translate }}
      </button>
      
    </div>
   
  </div>

</div>


<div class="modify-buttons-advisor" *ngIf="DisableEditAndCancel()">

<button (click)="cancelAppointment()" class="cancel-button">
  <span>{{ "CancelAppointment" | translate }}</span>
</button>

<button (click)="rescheduleAppointment()" class="edit-button">
  <span>{{ "UpdateSchedule" | translate }}</span>
</button>
</div>
